module.exports = __webpack_public_path__ + "media/dog-profile-avatars/multiple-dogs-c9fc7eed.svg";